import React, { Component } from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from "react-router-dom";
import { AuthService } from "../login/AuthService";
import Menu from "./Menu";
import Http from "../classes/Http";
import ProjectResultListPage from "../project/ProjectResultListPage";
import CourseResultListPage from "./CourseResultListPage";
import ExamResultInputPage from "./ExamResultInputPage";
import Dao from "../classes/Dao";
import LoginPage from "../login/LoginPage";
import OutputLog from "../project/OutputLog";
import ReviewForm from "../review/ReviewForm";
import CardWrapper from "../project/CardWrapper";
import ReviewFileList from "../review/ReviewFileList";
import AdminPage from "./AdminPage";
import ProjectResultPage from "../project/ProjectResultPage";
import ReviewList from "../review/ReviewList";
import ReviewConflictPage from "../review/ReviewConflictPage";
import ReviewCommentTable from "../review/ReviewCommentTable";
import CommentListPage from "../review/CommentListPage";
import DbInfoPage from "./DbInfoPage";
import TagMatchPage from "../match/TagMatchPage";
import TagMatchListPage from "../match/TagMatchListPage";
import RegistrationPage from "../comp/RegistrationPage";
import { ServiceCollection } from "./ServiceCollection";
import { UiSettings } from "../common/UiSettings";
import RegisteredListPage from "./RegisteredListPage";

class Main extends Component<RouteComponentProps, {}> {

    private services: ServiceCollection;

    async componentDidMount() {
        this.services = this.getServices();

        await this.loadUiSettings();

        this.setState({});
    }

    loadUiSettings() {
        if (!this.services.auth.isLoggedIn()) {
            return;
        }

        const currentUser = this.services.auth.getAuthCredentials().userName;

        return this.services.dao.getUiSettings(currentUser).then(settings => {
            this.services.uiSettings.load(settings);
            this.setState({});
        });
    }

    getServices(): ServiceCollection {
        const baseUrl = document['my-base-url'];

        const authService = new AuthService(this.getRepoName(baseUrl));

        let restrictedHandler = () => {
            authService.logOut();

            this.props.history.push('/login');
        };

        let http = new Http(baseUrl, authService, restrictedHandler);

        return {
            dao: new Dao(http),
            history: this.props.history,
            routeParams: this.props.match.params,
            location: this.props.location,
            auth: authService,
            uiSettings: new UiSettings(),
        };
    }

    getRepoName(url: string) {
        const names = ['icd0007', 'icd0011', 'icd0019'];
        for (const name of names) {
            if (url.includes(name)) {
                return name;
            }
        }
        throw new Error('Could not find repo name in url: ' + url);
    }

    render() {
        if (!this.services) {
            return '';
        }

        const services = this.services;

        if (!services.auth.isLoggedIn()) {
            return <LoginPage services={ this.services } />;
        }

        const currentUser = services.auth.getAuthCredentials().userName;

        return (
                <>

                <Menu services={ services } />

                <Switch>
                    <Route path="/results/:username" render={ (props: any) =>
                        <ProjectResultPage services={services}
                                           username={props.match.params.username} />
                    }>
                    </Route>
                    <Route path="/reviews/:username" render={ (props: any) =>
                        <div>
                            <ReviewList services={services}
                                        username={props.match.params.username} />

                            <ReviewCommentTable services={services}
                                                username={props.match.params.username} />
                        </div>
                    }>
                    </Route>
                    <Route exact path="/results">
                        <ProjectResultListPage services={ services } />
                    </Route>
                    <Route path="/output-log/:userName/:tag">
                        <OutputLog services={ services } />
                    </Route>
                    <Route exact path="/review/:reviewId" render={ (props: any) =>
                        <CardWrapper backLinkCb={ this.props.history.goBack }>
                            <ReviewForm reviewId={props.match.params.reviewId} services={ services } />
                        </CardWrapper> }>
                    </Route>
                    <Route exact path="/review-files/:reviewId" render={ (props: any) =>
                        <CardWrapper backLinkCb={ this.props.history.goBack }>
                            <ReviewFileList reviewId={props.match.params.reviewId} services={ services } />
                        </CardWrapper> }>
                    </Route>
                    <Route exact path="/comment-list/:username/:tag" render={ (props: any) =>
                        <CardWrapper backLinkCb={ this.props.history.goBack }>
                            <CommentListPage
                                username={props.match.params.username}
                                tag={props.match.params.tag}
                                services={ services } />
                        </CardWrapper> }>
                    </Route>
                    <Route path="/course-results">
                        <CourseResultListPage services={ services } />
                    </Route>
                    <Route exact path="/db-info/:username" render={ (props: any) =>
                        <DbInfoPage username={props.match.params.username}
                                    services={ services } /> }>
                    </Route>
                    <Route path="/input">
                        <ExamResultInputPage services={ services } />
                    </Route>
                    <Route path="/review-conflicts">
                        <ReviewConflictPage services={ services } />
                    </Route>
                    <Route exact path="/tag-matches">
                        <TagMatchListPage services={ services } />
                    </Route>
                    <Route exact path="/tag-matches/:tagMatchId" render={ (props: any) =>
                        <TagMatchPage tagMatchId={props.match.params.tagMatchId }
                                      services={ services } /> } >
                    </Route>
                    <Route path="/admin">
                        <AdminPage services={ services } />
                    </Route>
                    <Route exact path="/registration">
                        <RegistrationPage services={ services } />
                    </Route>
                    <Route exact path="/registered-list/:eventId" render={ (props: any) =>
                        <RegisteredListPage eventId={props.match.params.eventId}
                                            services={ services } /> }>
                    </Route>
                    <Route>
                        <Redirect to={"/results/" + currentUser} />
                    </Route>
                </Switch>
                </>
        );
    }
}

export default withRouter(Main)